import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { VideoCard, VideoLightbox, SectionTitle } from "../components/VideoCard";
import { Reveal } from "../hooks/useReveal";

export default function Portfolio() {
  const { content, videos } = useContent();
  const [playing, setPlaying] = useState(null);
  const main = videos.filter((v) => v.section === "portfolio").sort((a, b) => a.order - b.order);
  const verticals = videos.filter((v) => v.section === "verticals").sort((a, b) => a.order - b.order);
  const fun = videos.filter((v) => v.section === "fun").sort((a, b) => a.order - b.order);

  return (
    <div className="bg-[#141414] texture-dark">
      {/* Page hero — light gray with serif display title */}
      <section className="bg-[#d8d8d8] slant-bottom-right relative z-10" data-testid="portfolio-hero">
        <div className="max-w-5xl mx-auto px-6 md:px-12 pt-14 md:pt-20 pb-28 md:pb-40 text-center">
          <p className="kicker text-neutral-500 mb-5">Our Work</p>
          <h1 className="font-serif-display text-neutral-950 leading-none"
            style={{ fontSize: "clamp(58px, 11vw, 150px)" }} data-testid="portfolio-heading">
            {content.portfolio.heading}
          </h1>
          <hr className="border-neutral-900/70 max-w-3xl mx-auto mt-2" />
          <h3 className="font-comfortaa text-neutral-900 leading-relaxed mt-8 max-w-3xl mx-auto font-normal"
            style={{ fontSize: "clamp(17px, 2vw, 26px)" }}>
            {content.portfolio.intro}
          </h3>
        </div>
      </section>

      {/* Our Portfolio */}
      <section className="texture-dark pt-16 md:pt-20 pb-8" data-testid="portfolio-main-section">
        <div className="max-w-[1240px] mx-auto px-6 md:px-12">
          <Reveal>
            <SectionTitle>{content.portfolio.sectionMain}</SectionTitle>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12">
            {main.map((v, i) => (
              <Reveal key={v.id} delay={(i % 2) * 90}>
                <VideoCard video={v} onPlay={setPlaying} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Verticals */}
      {verticals.length > 0 && (
        <section className="texture-dark pt-16 md:pt-20 pb-8" data-testid="portfolio-verticals-section">
          <div className="max-w-[1240px] mx-auto px-6 md:px-12">
            <Reveal>
              <SectionTitle>{content.portfolio.sectionVerticals}</SectionTitle>
            </Reveal>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-12 max-w-4xl">
              {verticals.map((v, i) => (
                <Reveal key={v.id} delay={(i % 3) * 90}>
                  <VideoCard video={v} vertical onPlay={setPlaying} />
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* And Just For Fun… */}
      {fun.length > 0 && (
        <section className="texture-dark pt-16 md:pt-20 pb-8" data-testid="portfolio-fun-section">
          <div className="max-w-[1240px] mx-auto px-6 md:px-12">
            <Reveal>
              <SectionTitle>{content.portfolio.sectionFun}</SectionTitle>
            </Reveal>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12">
              {fun.map((v, i) => (
                <Reveal key={v.id} delay={(i % 2) * 90}>
                  <VideoCard video={v} onPlay={setPlaying} />
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="texture-dark pt-12 pb-20" data-testid="portfolio-contact-section">
        <Reveal className="text-center">
          <Link to="/contact" className="pill-button inline-block" data-testid="portfolio-contact-button">
            Contact Us
          </Link>
        </Reveal>
      </section>

      {playing && <VideoLightbox video={playing} onClose={() => setPlaying(null)} />}
    </div>
  );
}
